// Ripped from https://github.com/formio/formio.js/blob/master/src/components/select/editForm/Select.edit.data.js
export default [
    { key: 'idPath', ignore: true },
    { key: 'refreshOn', ignore: true },
    { key: 'refreshOnBlur', ignore: true },
    { key: 'clearOnRefresh', ignore: true },
    { key: 'customOptions', ignore: true },
    { key: 'readOnlyValue', ignore: true },
    { key: 'useExactSearch', ignore: true },
    { key: 'sort', ignore: true },
    { key: 'ignoreCache', ignore: true },
    { key: 'selectThreshold', ignore: true },
    { key: 'filter', ignore: true },
    { key: 'addResource', ignore: true },
    { key: 'reference', ignore: true },
    { key: 'selectFields', ignore: true },
    { key: 'dataType', ignore: true},
    { key: 'persistent', ignore: true},
    { key: 'protected', ignore: true},
    { key: 'dbIndex', ignore: true},
    { key: 'encrypted', ignore: true},
    { key: 'redrawOn', ignore: true},
    { key: 'customDefaultValuePanel', ignore: true},
    { key: 'calculateServer', ignore: true},
    { key: 'allowCalculateOverride', ignore: true},
    { key: 'inputFormat', ignore: true},
    { key: "searchDebounce", ignore: true},
    { key: "limit", ignore: true},
    { key: "defaultValue", ignore: true},
    // { key: 'template', hidden: true }, // needs to be enabled for resources to work
    {
        key: 'calculateValuePanel',
        ignore: false,
        components: [
            {
                html: "<p>You can use the <code>data</code> prefix to access other fields in the form via the name in their API tab. For example, <code>data.otherValue</code>.</p></code></p>",
                label: "Content",
                refreshOnChange: false,
                key: "calculatedValueInstructionsNU",
                type: "content",
                input: false,
                tableView: false
            },
        ]},
    {
        type: 'select',
        input: true,
        dataSrc: 'url',
        data: {
            url: '/form?type=resource&limit=1000000&select=_id,title',
        },
        authenticate: true,
        template: '<span>{{ item.title }}</span>',
        valueProperty: '_id',
        clearOnHide: false,
        label: 'Resource',
        key: 'data.resource',
        lazyLoad: false,
        weight: 10,
        tooltip: 'The resource to be used with this field.',
        conditional: {
            json: { '===': [{ var: 'data.dataSrc' }, 'resource'] },
        },
        currentResource: "", // Added this property to track users changing resources
        onChange(context) {
            if (context && context.flags && context.flags.modified) {
                let previousResource = context.component.currentResource;
                // Need to freeze the context instance in a string as it may change during code execution, also helps debugging
                context.component.currentResource = JSON.stringify(context.instance.data.data.resource)
                console.log(previousResource, context.component.currentResource);

                // I don't know why valueProperty's `refreshOn: data.resources` doesn't clear old values when switching resources
                // This workaround solves the issue of old resource values sticking around
                if (context.component.currentResource !== previousResource) {
                    context.instance.root.getComponent('template').setValue("");
                    context.instance.root.getComponent('searchField').setValue("");
                    context.instance.root.getComponent('valueProperty').setValue("");
                }
            }
        }
    },
    {
        type: 'textfield',
        disabled: true,
        input: true,
        key: 'searchField',
        label: 'Search Query Name',
        weight: 16,
        description: 'Name of URL query parameter',
        tooltip: 'The name of the search querystring parameter used when sending a request to filter results with. The server at the URL must handle this query parameter.',
        conditional: {
            json: {
                in: [
                    { var: 'data.dataSrc' },
                    [
                        'url',
                        'resource',
                    ],
                ],
            },
        },
    },
]
